import React, { memo, useState, useEffect } from 'react';
import { Flex } from 'antd-mobile';
import PropTypes from 'prop-types';
import { FrameWork, ImgWrap } from 'pubBiz';
import styles from './index.modules.less';

const { Shape } = FrameWork;

const defaultProps = {
  containerStyle: {},
  data: [],
  loadEnd: false,
  onPress: null
};

const propTypes = {
  width: PropTypes.any.isRequired, // Any 宽度 支持数字、百分比 必传
  data: PropTypes.array, // Array 数据源
  loadEnd: PropTypes.bool, // Boolen 是否加载完成
  onPress: PropTypes.func // Function 点击回调
};

const ModuleCell = memo((props) => {
  const {
    width, // Number 宽度
    containerStyle, // Object 容器额外样式
    data: dataSource, // Array 模块数据
    cardImgStyle, // 卡片式应用位，对应的图片的样式
    loadEnd, // Boolean 是否加载完成
    onPress // Function 点击回调
  } = props;
  const [data, setData] = useState([]);

  // 长辈模式不放大应用位：把 rem 尺寸乘上 --elder-image-scale 抵消根字体放大（默认 1，正常模式不变）。
  // 外层宽度基于 100vw、圆形格子宽度为百分比，均不随 rem 放大，无需处理。
  const scaleRem = (value) => `calc(${value} * var(--elder-image-scale, 1))`;

  useEffect(() => {
    if ((dataSource || []).length > 0) {
      let displayType = dataSource[0].displayType;
      if (displayType != 2) {
        setData((dataSource || []).filter((item, index) => index < 10));
      } else {
        setData((dataSource || []).filter((item, index) => index < 8));
      }
    } else {
      setData([]);
    }
  }, [dataSource]);

  // 获取每个应用位的独立样式
  const getCellStyle = (displayType, idx) => {
    let oneLineNumber = 5;
    let cellMarginL = 0; // 模块间距left
    let cellWidth = '20%'; // 模块宽度
    let cellMarginT = '0.3rem'; // 模块间距top

    if (displayType == 1) {
      // 圆形图标 displayType： 1 引入值计算会有浮点值出现，需要避免计算
      // 5个排布 宽度 20% 左间距0 上间距30
      // 4个排布 宽度 25% 左间距0 上间距30
      if (!(data.length % 5) || data.length >= 9) {
        oneLineNumber = 5;
        cellMarginL = 0;
        cellWidth = '20%';
      }

      if (data.length % 5 && data.length < 9) {
        oneLineNumber = 4;
        cellMarginL = 0;
        cellWidth = '25%';
      }

      cellMarginT = scaleRem('0.3rem');
    } else {
      // 卡片式 displayType： 2
      // 4个排布 宽度 168 间距10(改成8是因为浮点数取整后会超出布局)
      oneLineNumber = 4;
      cellMarginL = scaleRem('0.08rem');
      cellWidth = scaleRem('1.68rem');
      cellMarginT = scaleRem('0.08rem');
    }
    const cellMarginLeft = idx % oneLineNumber ? cellMarginL : 0;
    const cellMarginTop = idx < oneLineNumber ? 0 : cellMarginT;

    return {
      cellWidth,
      cellMarginLeft,
      cellMarginTop
    };
  };

  // 圆形图标
  const renderCircle = (item) => {
    const {
      imgUrl, // String 图片地址
      name // String 模块名称
    } = item;

    return (
      <React.Fragment>
        <ImgWrap w={scaleRem('1rem')} h={scaleRem('0.6rem')} src={imgUrl || ''} mode="discard" />
        <div className={styles.moduleBtnName}>
          <span>{name}</span>
        </div>
      </React.Fragment>
    );
  };

  // 卡片式
  const renderCard = (item) => {
    const {
      filletValue, // Number 圆角值
      imgUrl // String 图片地址
    } = item;

    return (
      <React.Fragment>
        <ImgWrap
          w={scaleRem((cardImgStyle && cardImgStyle.width) || '1.68rem')}
          h={scaleRem((cardImgStyle && cardImgStyle.height) || '1.98rem')}
          r={`${(filletValue || 0) / 100}rem`}
          src={imgUrl || ''}
          mode="cover"
        />
      </React.Fragment>
    );
  };

  if (loadEnd && !data.length) return null;

  if (!loadEnd) {
    return (
      <Flex
        flexDirection="row"
        align="start"
        wrap="wrap"
        style={{
          width,
          ...containerStyle
        }}>
        {new Array(10).fill(1).map((item, index) => {
          const itemW = `${100 / 5}%`;
          return (
            <Flex
              key={`module-cell-${index}`}
              align="center"
              justify="center"
              style={{ width: itemW, height: '1.4rem' }}>
              <Flex align="center" justify="center" direction="column">
                <Shape type="square" w="0.96rem" h="0.96rem" r="50%" />
                <Shape type="square" w="0.48rem" h="0.24rem" />
              </Flex>
            </Flex>
          );
        })}
      </Flex>
    );
  }

  return (
    <Flex
      flexDirection="row"
      align="start"
      wrap="wrap"
      style={{
        width,
        ...containerStyle
      }}>
      {data.map((item, itemIdx) => {
        const {
          displayType // Number 显示类型 1: 圆形图标 2: 卡片式
        } = item;

        const { cellWidth, cellMarginLeft, cellMarginTop } = getCellStyle(displayType, itemIdx);

        if (itemIdx > 10 || (itemIdx > 8 && displayType == 2)) return null;
        return (
          <Flex
            key={`module-cell-${itemIdx}`}
            direction="column"
            align="center"
            style={{
              width: cellWidth,
              marginLeft: cellMarginLeft,
              marginTop: cellMarginTop
            }}
            onClick={() => onPress && onPress(item)}>
            {displayType == 1 && renderCircle(item)}
            {displayType == 2 && renderCard(item)}
          </Flex>
        );
      })}
    </Flex>
  );
});

ModuleCell.defaultProps = defaultProps;
ModuleCell.propTypes = propTypes;

export default ModuleCell;



// WEBPACK FOOTER //
// ./src/pubBiz/CommonCell/ModuleCell/index.js